import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { MsgUnsubscribeService } from '../msg-unsubscribe.service';
import { MsgUnsubscribe } from '../msg-unsubscribe';
import { MsgUnsubscribeComponent } from '../msg-unsubscribe/msg-unsubscribe.component';

@Component({
    selector: 'app-msg-unsubscribe-list',
    templateUrl: './msg-unsubscribe-list.component.html',
    styleUrls: ['./msg-unsubscribe-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class MsgUnsubscribeListComponent implements OnInit {
	constructor(
		private msgUnsubscribeService: MsgUnsubscribeService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = msgUnsubscribeService.statuses;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	msgUnsubscribes: any;
	msgUnsubscribe: MsgUnsubscribe;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'msgUnsubscribeId', header: 'Id', width: 'auto' },
		{ field: 'emailAddress', header: 'Email Address', width: 'auto' },
		{ field: 'unsubscribeEmailId', header: 'UnSubscribe EmailId', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.msgUnsubscribeId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-msgUnsubscribe-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.msgUnsubscribeService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.msgUnsubscribes = res.data.msgUnsubscribes;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.msgUnsubscribes = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(msgUnsubscribe: MsgUnsubscribe) {
		try {
			this.formLoading = true;
			this.msgUnsubscribeService.update(msgUnsubscribe)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.msgUnsubscribes.map((msgUnsubscribe, i) => {
							if (msgUnsubscribe.msgUnsubscribeId === res.data.msgUnsubscribe.msgUnsubscribeId) {
								this.msgUnsubscribes[i] = res.data.msgUnsubscribe;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(msgUnsubscribe: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(msgUnsubscribe));

			this.formLoading = true;
			this.msgUnsubscribeService.delete(msgUnsubscribe.msgUnsubscribeId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.msgUnsubscribes.splice(this.msgUnsubscribes.indexOf(msgUnsubscribe), 1);
						this.recordTotal = this.msgUnsubscribes.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'MsgUnsubscribe ' + msgUnsubscribe.msgUnsubscribeId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'MsgUnsubscribe ' + msgUnsubscribe.msgUnsubscribeId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add MsgUnsubscribe'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(MsgUnsubscribeComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addMsgUnsubscribeCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(msgUnsubscribe: MsgUnsubscribe) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			msgUnsubscribe: msgUnsubscribe,
			title: 'Edit MsgUnsubscribe'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(MsgUnsubscribeComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateMsgUnsubscribeCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteMsgUnsubscribeCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addMsgUnsubscribeCB(msgUnsubscribe: MsgUnsubscribe) {
		console.log('Adding MsgUnsubscribe: ' + JSON.stringify(msgUnsubscribe));
		// if we don't have a msgUnsubscribes array yet...
		if (!this.msgUnsubscribes) {
			this.msgUnsubscribes = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.msgUnsubscribes.unshift(msgUnsubscribe);

		// no idea what this is but it is required to update the array
		this.msgUnsubscribes = [...this.msgUnsubscribes];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'MsgUnsubscribe ' + msgUnsubscribe.msgUnsubscribeId + ' Added', life: 3000 });
	}

	updateMsgUnsubscribeCB(msgUnsubscribe: MsgUnsubscribe) {
		console.log('Updating MsgUnsubscribe: ' + JSON.stringify(msgUnsubscribe));
		let itemIndex = this.msgUnsubscribes.findIndex((item: any) => item.msgUnsubscribeId === msgUnsubscribe.msgUnsubscribeId);
		this.msgUnsubscribes[itemIndex] = msgUnsubscribe;

		// no idea what this is but it is required to update the array
		this.msgUnsubscribes = [...this.msgUnsubscribes];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'MsgUnsubscribe ' + msgUnsubscribe.msgUnsubscribeId + ' Updated', life: 3000 });
	}

	deleteMsgUnsubscribeCB(msgUnsubscribe: MsgUnsubscribe) {
		console.log('Removing MsgUnsubscribe: ' + msgUnsubscribe);
		this.msgUnsubscribes.splice(this.msgUnsubscribes.indexOf(msgUnsubscribe), 1);
		this.recordTotal = this.msgUnsubscribes.length;

		// no idea what this is but it is required to update the array
		this.msgUnsubscribes = [...this.msgUnsubscribes];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'MsgUnsubscribe ' + msgUnsubscribe.msgUnsubscribeId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.msgUnsubscribes ? this.first === (this.msgUnsubscribes.length - this.rows) : true; }
	isFirstPage(): boolean { return this.msgUnsubscribes ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(msgUnsubscribe: any) {
		if (msgUnsubscribe?.status) {
			const status = this.statuses.find((e: any) => e.value == msgUnsubscribe.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}
}
